import {
    MoreHorizontal,
    Fence,
} from "lucide-react"

import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarMenu, SidebarMenuButton,
    SidebarMenuItem
} from "@uavity-core/ui/components/sidebar"
import { useGeofencesQueryV1, getGeofenceIdentifier } from "@/api/v1/geofence/geofence-api"
import { Link } from "@tanstack/react-router"



export function NavGeofences() {

    const { data: geofences, isPending, isError } = useGeofencesQueryV1()


    return (
        <SidebarGroup className="group-data-[collapsible=icon]:hidden">
            <SidebarGroupLabel>Geofences</SidebarGroupLabel>
            <SidebarMenu>
                {isPending && <p>loading..</p>}
                {isError && <p>Something bad happened</p>}
                {geofences?.slice(0, 3).map((item) => {
                    const identifier = getGeofenceIdentifier(item);
                    return (
                        <SidebarMenuItem key={identifier}>
                            <SidebarMenuButton asChild>
                                <Link to={'/geofences/$geofenceId'} params={{ geofenceId: String(identifier) }}>
                                    <Fence />
                                    <span>{item.name}</span>
                                </Link>
                            </SidebarMenuButton>
                        </SidebarMenuItem>
                    );
                })}
                <SidebarMenuItem>
                    <Link to="/geofences">
                        <SidebarMenuButton className="text-sidebar-foreground/70">
                            <MoreHorizontal className="text-sidebar-foreground/70" />
                            <span>More</span>
                        </SidebarMenuButton>
                    </Link>
                </SidebarMenuItem>
            </SidebarMenu>
        </SidebarGroup>
    )
}
